// autopilot-doctor-mattermost-check.ts — P7 test 53: doctor-facing wrapper
// around mattermost-sync.ts's checkMattermostBotCapabilities (P4b), split
// out of autopilot-doctor.ts (already at the 200-line convention ceiling).
// Reports missing bot identity/membership/post permission clearly, and
// NEVER includes the bot token in its output — the `reason` string returned
// by checkMattermostBotCapabilities already excludes it (P4b: "never
// interpolate the token into the error message"), and this wrapper accepts
// no token parameter that could leak into `detail` even by accident (the
// `botTokenForRedactionCheckOnly` dep exists ONLY so the unit test can prove
// a token-shaped value passed alongside deps never appears in the result).
import type { AutopilotCheckResult } from "./autopilot-doctor.js";
import type { MattermostBotCapabilities } from "./mattermost-sync.js";

export interface MattermostDoctorCheckDeps {
  checkCapabilities: () => Promise<MattermostBotCapabilities>;
  /** Test-only: proves the checker never leaks a token-shaped value into its output. */
  botTokenForRedactionCheckOnly?: string;
}

export async function checkMattermostBotPermissionForDoctor(
  deps: MattermostDoctorCheckDeps,
): Promise<AutopilotCheckResult> {
  const capabilities = await deps.checkCapabilities();

  if (capabilities.identityOk && capabilities.channelMembershipOk && capabilities.canPost) {
    return {
      name: "Mattermost bot permission",
      status: "ok",
      detail: "Bot có identity hợp lệ, là thành viên channel, và có quyền post.",
    };
  }

  const missing: string[] = [];
  if (!capabilities.identityOk) missing.push("identity");
  if (!capabilities.channelMembershipOk) missing.push("channel membership");
  if (!capabilities.canPost) missing.push("quyền post");

  return {
    name: "Mattermost bot permission",
    status: "fail",
    detail:
      `Thiếu: ${missing.join(", ")}` +
      (capabilities.reason ? ` (reason=${capabilities.reason})` : "") +
      ". Kiểm tra bot token/membership trong .mattermost/credentials.json — token KHÔNG được in ra đây.",
  };
}
